export default "__VITE_ASSET__Dh0_Kb1p__"